import { css } from '@emotion/react'
import {
  Color,
  FontWeight,
  Size,
  Spacing,
  Typography,
  ZIndex,
} from '@opallabs/gem'

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.XS,
  padding: `${Spacing.M}px 0`,

  ':not(:last-child)': {
    borderBlockEnd: `1px solid ${Color.light['Strokes/Secondary-1']}`,
  },
})

export const header = css({
  display: 'flex',
  gap: Spacing.S,
  alignItems: 'center',
})

export const name = css({
  ...Typography.T500,
  fontWeight: FontWeight.Bold,
  whiteSpace: 'nowrap',
  color: Color.light['Text/Primary'],
})

export const timeDistance = css({
  ...Typography.T500,
  lineHeight: `${Spacing.M}px`,
  color: Color.light['Text/Secondary'],
})

export const contentContainer = css({
  ...Typography.T500,
  color: Color.light['Text/Primary'],
  fontSize: 16,
  paddingInlineStart: Spacing.L + Spacing.S,
})

export const content = css({
  color: Color.light['Text/Primary'],
  textAlign: 'start',

  '& > :first-child': {
    marginBlockStart: 0,
  },

  'p, h1, h2, h3, h4': {
    marginBlock: '4px',
    marginInline: '0',
  },

  '[data-type="mention"]': {
    backgroundColor: Color.light['Color/Primary/Primary-3'],
    borderRadius: Spacing.XS,
    color: Color.light['Text/Links'],
    padding: `${Spacing.XS / 2}px ${Spacing.XS}px`,
  },
})
export const optionButton = css({
  maxInlineSize: '24px',
  maxBlockSize: '24px',
  color: Color.light['Icons/Secondary'],
  marginInlineEnd: Spacing.XS,
})

export const optionMenu = css({
  minInlineSize: '180px',
  zIndex: ZIndex.Shroud.Popover,
})

export const optionMenuItem = css({
  display: 'flex',
  gap: Spacing.XS,
  alignItems: 'center',
})

export const textAndActionsContainer = css({
  borderRadius: Size.Rounding * 3,
  border: `1px solid ${Color.light['Strokes/Secondary-1']}`,
  backgroundColor: Color.light['Color/Surface/Surface-2'],
  paddingInline: Spacing.S,
  paddingBlock: Spacing.S,

  '&:only-child': {
    borderRadius: Size.Rounding * 2,
  },

  '&:focus-within': {
    borderColor: Color.light['Strokes/Primary-2'],
    backgroundColor: Color.light['Color/Surface/Surface-1'],
  },
})

export const textInput = css({
  border: 'none',
  padding: 0,
  inlineSize: '100%',
  backgroundColor: 'transparent',

  scrollbarColor: 'transparent transparent',
  '::webkit-scrollbar': {
    display: 'none',
  },

  '&:active:enabled, &:focus:enabled': {
    border: `none`,
  },
})

export const footerActions = css({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  overflow: 'hidden',
  paddingBlockStart: Spacing.S,
  opacity: 1,
  blockSize: '32px',
})
